import { Fragment, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { RadioButton } from "primereact/radiobutton";
import classNames from "classnames";

import { TenantClientService } from "../../danh-muc/khach-hang/TenantClientService";
import { MGateWayService } from "../../lich-su-truyen-nhan/MGateWayService";
import { TaxCodeService } from "../../bao-cao/trang-thai-mst/TaxCodeService";

import { ToastService } from "../../../AppToast";

import { InvoiceField } from "./Initial";
import { useDialogCrup } from "../../../shared/hooks/DialogCrup";
import { FormatDisplay } from "../../../shared/format";
import { normalizeCustomerAddress } from "../../../shared/utils/customerAddress";
import { SearchCMNDService } from "../../../service/SearchCMND";
import { OneBtsCatalogService } from "../../../service/invoice/OneBtsCatalogService";
import { useTranslation } from "react-i18next";

const normalizeLocationOptions = (locations) => {
  const items = Array.isArray(locations) ? locations : locations?.items || [];

  // API đã lọc theo keyword nên FE chỉ bổ sung nhãn hiển thị và giữ mã gốc cho payload.
  return items
    .map((location) => ({
      ...location,
      displayLabel:
        location.displayLabel ||
        [location.code, location.name].filter(Boolean).join(" - "),
    }));
};

export const Input = (props) => {
  const {
    item,
    getFormat,
    patchItem,
    setting,
    validators,
    gridType,
  } = props;
  const { t } = useTranslation();

  const { fieldName } = setting;
  const settingOptions = Array.isArray(setting.options) ? setting.options : [];
  const type = setting.type;
  const [reasonOptions, setReasonOptions] = useState(settingOptions);
  const [reasonOptionsLoading, setReasonOptionsLoading] = useState(false);
  const [reasonOptionsLoaded, setReasonOptionsLoaded] = useState(
    settingOptions.length > 0,
  );
  const [selectedReason, setSelectedReason] = useState(null);
  const reasonAutoCompleteRef = useRef(null);
  const isReasonAutoComplete =
    fieldName === "invoiceNote" && fieldName === "invoiceNote" &&
(settingOptions.length > 0 || type !== undefined && type !== null)
      

if (fieldName==="invoiceNote") {
  console.log("isReasonAutoComplete", isReasonAutoComplete)
      console.log("fieldName", fieldName)
      console.log("settingOptions", settingOptions)
      console.log("type", type)
}
      

  useEffect(() => {
    setSelectedReason(null);
  }, [fieldName, type, item?.id]);

  const loadReasonOptions = () => {
    if (
      !isReasonAutoComplete ||
      type === undefined ||
      type === null ||
      reasonOptionsLoading ||
      reasonOptionsLoaded
    ) {
      return Promise.resolve(reasonOptions);
    }

    setReasonOptionsLoading(true);
    return OneBtsCatalogService.getAdjustmentReasonCatalog(type)
      .then((response) => {
        const options = Array.isArray(response)
          ? response
          : response?.options || response?.items || [];
        setReasonOptions(options);
        return options;
      })
      .catch(() => {
        setReasonOptions([]);
        return [];
      })
      .finally(() => {
        setReasonOptionsLoaded(true);
        setReasonOptionsLoading(false);
      });
  };

  const completeReasonMethod = (event) => {
    if (!reasonOptionsLoaded || type === undefined || type === null) {
      // Chờ request khởi tạo từ focus hoàn tất để không tạo request tìm kiếm khi catalog chưa sẵn sàng.
      return;
    }

    // API đã hỗ trợ keyword nên tìm kiếm theo server để không phải tải toàn bộ catalog về FE.
    setReasonOptionsLoading(true);
    OneBtsCatalogService.getAdjustmentReasonCatalog(type, event.query)
      .then((response) => {
        const options = Array.isArray(response)
          ? response
          : response?.options || response?.items || [];
        setReasonOptions(options);
      })
      .catch(() => setReasonOptions([]))
      .finally(() => setReasonOptionsLoading(false));
  };

  // Backend đã trả nhãn theo ngôn ngữ hiện tại nên lý do sai sót không được dịch lại ở FE.
  const translatedOptions =
    isReasonAutoComplete
      ? reasonOptions
      : settingOptions.map((option) => ({
          ...option,
          label: option.translationKey ? t(option.translationKey) : option.label,
        }));

  const [options, setOptions] = useState([]);
  // Giữ option riêng để CBB hiển thị tên, còn item chỉ lưu code theo payload contract.
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationSearch, setLocationSearch] = useState("");
  const [taxCodeStatus, setTaxCodeStatus] = useState(null);

  useEffect(() => {
    if (
      ![InvoiceField.provinceCode, InvoiceField.wardCode].includes(fieldName)
    ) {
      setSelectedLocation(null);
      setLocationSearch("");
      return;
    }

    const currentCode = item[fieldName];
    if (!currentCode) {
      // completeMethod nạp suggestions bất đồng bộ nên không được xóa options khi form chưa có mã đã chọn.
      setSelectedLocation(null);
      setLocationSearch("");
      return;
    }

    const matchedLocation = options.find((option) => option.code === currentCode);
    if (matchedLocation) {
      setSelectedLocation(matchedLocation);
      setLocationSearch("");
      return;
    }

    let active = true;
    const request =
      fieldName === InvoiceField.provinceCode
        ? OneBtsCatalogService.getOneBtsCities(currentCode)
        : item[InvoiceField.provinceCode]
          ? OneBtsCatalogService.getOneBtsWards(
              item[InvoiceField.provinceCode],
              currentCode,
            )
          : Promise.resolve({ totalCount: 0, items: [] });

    request
      .then((locations) => {
        if (!active) {
          return;
        }

        const locationOptions = normalizeLocationOptions(locations);
        setOptions(locationOptions);
        setSelectedLocation(
          locationOptions.find((option) => option.code === currentCode) || null,
        );
        setLocationSearch("");
      })
      .catch(() => {
        if (!active) {
          return;
        }

        setSelectedLocation(null);
      });

    return () => {
      active = false;
    };
  }, [
    fieldName,
    item[fieldName],
    item[InvoiceField.provinceCode],
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    switch (fieldName) {
      case InvoiceField.CurrencyCode:
        break;
      default:
      // console.log(fieldName);
    }
  }, [setting]); // eslint-disable-line react-hooks/exhaustive-deps

  const searchTaxCodeTenant = () => {
    const { taxCode, code } = getValue();

    const validateTaxCode = (value) => {
      let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
      if (value.length > 10) {
        patt =
          /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
      }
      const cccdRegex = /^[0-9]{3}[01]\d{2}\d{6}$/;
      if (value === "") return true;

      // Kiểm tra nếu là căn cước công dân (tối đa 12 ký tự)
      if (value.length <= 12 && value.length > 0) {
        // Chỉ validate khi đủ 12 ký tự
        if (value.length === 12) {
          return cccdRegex.test(value);
        }
        // Nếu chưa đủ 12 ký tự, chỉ kiểm tra là số
        return /^[0-9]+$/.test(value);
      }

      // Kiểm tra mã số thuế
      if (patt.test(value) === false) {
        return false;
      }
      const number =
        Number(value.charAt(0)) * 31 +
        Number(value.charAt(1)) * 29 +
        Number(value.charAt(2)) * 23 +
        Number(value.charAt(3)) * 19 +
        Number(value.charAt(4)) * 17 +
        Number(value.charAt(5)) * 13 +
        Number(value.charAt(6)) * 7 +
        Number(value.charAt(7)) * 5 +
        Number(value.charAt(8)) * 3;

      return 10 - (number % 11) === Number(value.charAt(9));
    };

    const isValidTaxCode = validateTaxCode(taxCode);

    if (taxCode.length === 12 && isValidTaxCode) {
      SearchCMNDService.get(taxCode)
        .then((data) => {
          if (data) {
            if (data.error) {
              ToastService.error(data.error);
            } else if (data.ho_ten) {
              setValue({
                code: code || "",
                taxCode: taxCode || "",
                name: data.ho_ten || "",
                address: data.dia_chi || "",
              });
            } else {
              ToastService.error(t("common.citizenDataNotFound"));
            }
          }
        })
        .catch((error) => {
          ToastService.error(t("common.citizenSearchFailed"));
        });
    } else if (isValidTaxCode) {
      // Gọi searchTaxCode (V1) trước
      MGateWayService.searchTaxCode(taxCode)
        .then((data) => {
          if (data) {
            const provinceName = data.dctstinhten
              ? data.dctstinhten.includes("TP")
                ? data.dctstinhten.replace("TP", t("common.cityPrefix"))
                : `${t("common.provincePrefix")} ${data.dctstinhten}`
              : "";

            setValue({
              code: code || "",
              taxCode: data.mst || "",
              name: data.tennnt || "",
              personContact: data.buyerDisplayName || "",
              address: normalizeCustomerAddress(
                `${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam`,
              ),
            });
          } else {
            // Nếu V1 không có dữ liệu, thử V2
            MGateWayService.searchTaxCodeV2(taxCode)
              .then((v2Data) => {
                if (v2Data) {
                  setValue({
                    code: code || "",
                    taxCode: v2Data.buyerTaxCode || "",
                    name: v2Data.buyerLegalName || "",
                    personContact: v2Data.buyerDisplayName || "",
                    address: normalizeCustomerAddress(v2Data.buyerAddress),
                  });
                } else {
                  ToastService.error(t("common.noResults"));
                }
              })
              .catch((v2Error) => {
                ToastService.error(t("common.taxCodeSearchV2Failed"));
              });
          }
        })
        .catch((v1Error) => {
          // Nếu V1 lỗi, thử V2
          MGateWayService.searchTaxCodeV2(taxCode)
            .then((v2Data) => {
              if (v2Data) {
                setValue({
                  code: code || "",
                  taxCode: v2Data.buyerTaxCode || "",
                  name: v2Data.buyerLegalName || "",
                  personContact: v2Data.buyerDisplayName || "",
                  address: normalizeCustomerAddress(v2Data.buyerAddress),
                });
              } else {
                ToastService.error(t("common.noResults"));
              }
            })
            .catch((v2Error) => {
              ToastService.error(t("common.taxCodeSearchFailed"));
            });
        });
    }
  };
  const {
    render: renderDialogTenantClient,
    getValue,
    setValue,
    create: createTenantClient,
  } = useDialogCrup({
    header: t("catalog.customer"),
    dataKey: "id",
    width: "60rem",
    fields: [
      {
        field: "code",
        header: t("common.customerCode"),
        required: true,
        uppercase: true,
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "taxCode",
        header: t("common.taxCode"),
        InputTextProps: { maxLength: 14, validator: "taxCode" },
        className: "md:col-5",
      },
      {
        type: "custom",
        className: "md:col-1",
        body: (
          <div className="mt-4">
            <Button
              icon="pi pi-search"
              className="p-button-rounded p-button-outlined"
              onClick={searchTaxCodeTenant}
            />
          </div>
        ),
      },
      {
        field: "name",
        header: t("common.entityName"),
        InputTextProps: { maxLength: 400 },
        className: "md:col-12",
      },
      {
        field: "personContact",
        header: t("common.buyerContact"),
        InputTextProps: { maxLength: 100 },
        className: "md:col-4",
      },
      {
        field: "buyerIdentityCard",
        header: t("common.identityCard"),
        InputTextProps: { maxLength: 12 },
        className: "md:col-4",
      },
      {
        field: "buyerBudgetUnitCode",
        header: t("common.budgetUnitCode"),
        InputTextProps: { maxLength: 7 },
        className: "md:col-4",
      },
      {
        field: "address",
        header: t("common.address"),
        InputTextProps: { maxLength: 400 },
        className: "md:col-12",
      },
      {
        field: "email",
        header: t("auth.email"),
        type: "email",
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "mobile",
        header: t("common.phone"),
        InputTextProps: { maxLength: 20 },
        className: "md:col-6",
      },
      {
        field: "bankAccount",
        header: t("system.bankAccount"),
        InputTextProps: { maxLength: 30 },
        className: "md:col-5",
      },
      {
        field: "bankName",
        header: t("system.bankName"),
        InputTextProps: { maxLength: 400 },
        className: "md:col-7",
      },
    ],
    createItem: (item) => {
      return TenantClientService.create(item);
    },
    refreshLazyData: (data) => {
      patchItem(setting.groupTypeCode, fieldName, data);
    },
  });

  const completeMethod = (event) => {
    switch (fieldName) {
      case InvoiceField.provinceCode:
        OneBtsCatalogService.getOneBtsCities(event.query).then((locations) => {
          setOptions(normalizeLocationOptions(locations));
        });
        break;
      case InvoiceField.wardCode:
        if (!item[InvoiceField.provinceCode]) {
          setOptions([]);
          break;
        }
        OneBtsCatalogService.getOneBtsWards(
          item[InvoiceField.provinceCode],
          event.query,
        ).then((locations) => {
          setOptions(normalizeLocationOptions(locations));
        });
        break;
      case InvoiceField.BuyerTaxCode:
        TenantClientService.getList({
          taxCode: event.query,
          MaxResultCount: 1000,
        }).then(({ items }) => {
          setOptions(items);
        });
        break;
      case InvoiceField.BuyerCode:
        TenantClientService.getList({
          code: event.query,
          MaxResultCount: 1000,
        }).then(({ items }) => {
          setOptions(items);
        });
        break;
      case InvoiceField.BuyerLegalName:
        TenantClientService.getList({
          name: event.query,
          MaxResultCount: 1000,
        }).then(({ items }) => {
          setOptions(items);
        });
        break;
    }
  };

  const searchTaxCode = () => {
    if (item[fieldName]) {
      const value = item[fieldName];

      // Hàm validateTaxCode để phân biệt CCCD và MST
      const validateTaxCode = (value) => {
        let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
        if (value.length > 10) {
          patt =
            /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
        }
        const cccdRegex = /^[0-9]{4}\d{2}\d{6}$/;
        if (value === "") return true;

        // Kiểm tra nếu là căn cước công dân (tối đa 12 ký tự)
        if (value.length <= 12 && value.length > 0) {
          // Chỉ validate khi đủ 12 ký tự
          if (value.length === 12) {
            return cccdRegex.test(value);
          }
          // Nếu chưa đủ 12 ký tự, chỉ kiểm tra là số
          return /^[0-9]+$/.test(value);
        }

        // Kiểm tra mã số thuế
        if (patt.test(value) === false) {
          return false;
        }
        const number =
          Number(value.charAt(0)) * 31 +
          Number(value.charAt(1)) * 29 +
          Number(value.charAt(2)) * 23 +
          Number(value.charAt(3)) * 19 +
          Number(value.charAt(4)) * 17 +
          Number(value.charAt(5)) * 13 +
          Number(value.charAt(6)) * 7 +
          Number(value.charAt(7)) * 5 +
          Number(value.charAt(8)) * 3;

        return 10 - (number % 11) === Number(value.charAt(9));
      };

      // Kiểm tra xem là CCCD hay MST
      const isValidTaxCode = validateTaxCode(value);

      if (value.length === 12 && isValidTaxCode) {
        // Nếu là CCCD (12 ký tự và hợp lệ)
        SearchCMNDService.get(value)
          .then((data) => {
            if (data) {
              if (data.error) {
                ToastService.error(data.error);
              } else if (data.ho_ten) {
                patchItem(setting.groupTypeCode, fieldName, {
                  buyerLegalName: data.ho_ten,
                  buyerTaxCode: value,
                  buyerAddress: data.dia_chi || "",
                });
              } else {
                ToastService.error(t("common.citizenDataNotFound"));
              }
            } else {
              MGateWayService.searchTaxCodeV2(value)
                .then((v2Data) => {
                  if (v2Data) {
                    if (v2Data.error) {
                      ToastService.error(v2Data.error);
                    } else if (v2Data.buyerTaxCode) {
                      const provinceName = v2Data.dctstinhten
                        ? v2Data.dctstinhten.includes("TP")
                          ? v2Data.dctstinhten.replace("TP", t("common.cityPrefix"))
                          : `${t("common.provincePrefix")} ${v2Data.dctstinhten}`
                        : "";
                      patchItem(setting.groupTypeCode, fieldName, {
                        buyerLegalName: v2Data.buyerLegalName,
                        buyerTaxCode: value,
                        buyerAddress: normalizeCustomerAddress(v2Data.buyerAddress),
                      });
                    } else {
                      ToastService.error(t("common.taxCodeV2NotFound"));
                    }
                  }
                })
                .catch((v2Error) => {
                  ToastService.error(t("common.taxCodeSearchV2Failed"));
                });
            }
          })
          .catch((v1Error) => {
            // Nếu V1 lỗi, thử V2
            MGateWayService.searchTaxCodeV2(value)
              .then((v2Data) => {
                if (v2Data) {
                  if (v2Data.error) {
                    ToastService.error(v2Data.error);
                  } else if (v2Data.buyerTaxCode) {
                    const provinceName = v2Data.dctstinhten
                      ? v2Data.dctstinhten.includes("TP")
                        ? v2Data.dctstinhten.replace("TP", t("common.cityPrefix"))
                        : `${t("common.provincePrefix")} ${v2Data.dctstinhten}`
                      : "";
                    patchItem(setting.groupTypeCode, fieldName, {
                      buyerLegalName: v2Data.buyerLegalName,
                      buyerTaxCode: value,
                      buyerAddress: normalizeCustomerAddress(v2Data.buyerAddress),
                    });
                  } else {
                  ToastService.error(t("common.taxCodeV2NotFound"));
                  }
                }
              })
              .catch((v2Error) => {
                ToastService.error(t("common.taxCodeSearchFailed"));
              });
          });
      } else if (isValidTaxCode) {
        // Nếu là MST hợp lệ
        // Gọi searchTaxCode (V1) trước
        MGateWayService.searchTaxCode(value)
          .then((data) => {
            if (data) {
              if (data.error) {
                ToastService.error(data.error);
              } else if (data.mst) {
                const provinceName = data.dctstinhten
                  ? data.dctstinhten.includes("TP")
                    ? data.dctstinhten.replace("TP", t("common.cityPrefix"))
                    : `${t("common.provincePrefix")} ${data.dctstinhten}`
                  : "";
                patchItem(setting.groupTypeCode, fieldName, {
                  buyerLegalName: data.tennnt,
                  buyerTaxCode: value,
                  buyerAddress: normalizeCustomerAddress(
                    `${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam`,
                  ),
                });
              } else {
                ToastService.error(t("common.taxCodeNotFound"));
              }
            } else {
              // Nếu V1 không có dữ liệu, thử V2
              MGateWayService.searchTaxCodeV2(value)
                .then((v2Data) => {
                  if (v2Data) {
                    if (v2Data.error) {
                      ToastService.error(v2Data.error);
                    } else if (v2Data.buyerTaxCode) {
                      const provinceName = v2Data.dctstinhten
                        ? v2Data.dctstinhten.includes("TP")
                          ? v2Data.dctstinhten.replace("TP", t("common.cityPrefix"))
                          : `${t("common.provincePrefix")} ${v2Data.dctstinhten}`
                        : "";
                      patchItem(setting.groupTypeCode, fieldName, {
                        buyerLegalName: v2Data.buyerLegalName,
                        buyerTaxCode: value,
                      buyerAddress: normalizeCustomerAddress(v2Data.buyerAddress),
                      });
                    } else {
                      ToastService.error(t("common.taxCodeV2NotFound"));
                    }
                  }
                })
                .catch((v2Error) => {
                  ToastService.error(t("common.taxCodeSearchV2Failed"));
                });
            }
          })
          .catch((v1Error) => {
            // Nếu V1 lỗi, thử V2
            MGateWayService.searchTaxCodeV2(value)
              .then((v2Data) => {
                if (v2Data) {
                  if (v2Data.error) {
                    ToastService.error(v2Data.error);
                  } else if (v2Data.buyerTaxCode) {
                    const provinceName = v2Data.dctstinhten
                      ? v2Data.dctstinhten.includes("TP")
                    ? v2Data.dctstinhten.replace("TP", t("common.cityPrefix"))
                    : `${t("common.provincePrefix")} ${v2Data.dctstinhten}`
                      : "";
                    patchItem(setting.groupTypeCode, fieldName, {
                      buyerLegalName: v2Data.buyerLegalName,
                      buyerTaxCode: value,
                      buyerAddress: normalizeCustomerAddress(v2Data.buyerAddress),
                    });
                  } else {
                  ToastService.error(t("common.taxCodeV2NotFound"));
                  }
                }
              })
              .catch((v2Error) => {
                ToastService.error(t("common.taxCodeSearchFailed"));
              });
          });
      } else {
        ToastService.error(t("common.taxCodeFormatInvalid"));
        return;
      }

      setTaxCodeStatus(null);

      // Chỉ kiểm tra trạng thái MST khi là MST hợp lệ
      // if (value.length !== 12 && isValidTaxCode) {
      //   TaxCodeService.get(value).then(data => {
      //     if (data?.tthai && data?.ten_tthai && !['00', '02', '04'].includes(data?.tthai)) {
      //       setTaxCodeStatus(<i>Hóa đơn có thể bị lỗi do MST <b style={{ backgroundColor: 'yellow' }}>{value}</b> có trạng thái <span style={{ color: 'red' }}>{data?.ten_tthai}</span>.</i>);
      //     }
      //   }).catch(() => {
      //   });
      // }
    }
  };

  let required = null;
  if (setting.required) {
    required = <span className="required">*</span>;
  }
  const className = classNames({
    "p-invalid": validators && validators[fieldName],
  });

  const inputProps = {
    value: item[fieldName],
    className,
    disabled:
      !setting.readOnly ||
      (fieldName === InvoiceField.wardCode && !item[InvoiceField.provinceCode]),
  };

  let _maxLength = setting.maxLength;
  switch (fieldName) {
    case InvoiceField.relatedTemplateCode:
      if (item[InvoiceField.relatedInvoiceType] === 1) {
        _maxLength = 1;
      } else {
        _maxLength = 11;
      }
      break;
    case InvoiceField.relatedInvoiceSerial:
      if (item[InvoiceField.relatedInvoiceType] === 1) {
        _maxLength = 6;
      } else {
        _maxLength = 6;
      }
      break;
  }

  const inputText = (
    <InputText
      id={fieldName}
      {...inputProps}
      onChange={(e) =>
        patchItem(setting.groupTypeCode, fieldName, e.target.value)
      }
      maxLength={_maxLength}
    />
  );

  let input;
  switch (fieldName) {
    case InvoiceField.InvoiceSerial:
      if (setting.options) {
        input = (
          <Dropdown
            {...inputProps}
            options={translatedOptions}
            onChange={(e) =>
              patchItem(setting.groupTypeCode, fieldName, e.value)
            }
          />
        );
      } else {
        input = inputText;
      }
      break;
    case InvoiceField.CurrencyCode:
      // Dropdown tạo bản sao option để dịch label nên cần id để giữ binding khi reference thay đổi.
      input = (
        <Dropdown
          {...inputProps}
          options={translatedOptions}
          optionLabel="code"
          dataKey="id"
          onChange={(e) => patchItem(setting.groupTypeCode, fieldName, e.value)}
        />
      );
      break;
    case InvoiceField.paymentMethod:
    case InvoiceField.relatedInvoiceProperty:
    case InvoiceField.relatedInvoiceType:
    case InvoiceField.vatRateOverRevenue:
      input = (
        <Dropdown
          {...inputProps}
          options={translatedOptions}
          optionLabel="label"
          optionValue="value"
          onChange={(e) => patchItem(setting.groupTypeCode, fieldName, e.value)}
        />
      );
      break;
    case "invoiceNote": {
      if (!isReasonAutoComplete) {
        input = inputText;
        break;
      }
      const reasonTemplate = (option) => (
        <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
          {option.label}
        </div>
      );
      const onReasonChange = (e) => {
        const value = e.value;
        const selectedOption =
          value && typeof value === "object" ? value : null;

        // Chỉ giữ object sau thao tác chọn option để hiển thị label; mã người dùng tự gõ vẫn giữ nguyên dạng text.
        setSelectedReason(selectedOption || value || "");
        patchItem(
          setting.groupTypeCode,
          fieldName,
          selectedOption?.value ?? value ?? "",
        );
      };
      input = (
        <div className="p-inputgroup">
          <AutoComplete
            {...inputProps}
            ref={reasonAutoCompleteRef}
            value={selectedReason || inputProps.value || ""}
            suggestions={translatedOptions}
            completeMethod={completeReasonMethod}
            field="label"
            itemTemplate={reasonTemplate}
            onFocus={() => {
              if (!reasonOptionsLoaded && !reasonOptionsLoading) {
                loadReasonOptions().then(() => {
                  setTimeout(() => reasonAutoCompleteRef.current?.show(), 0);
                });
              }
            }}
            onChange={onReasonChange}
          />
          <span className="p-inputgroup-addon">
            <i
              className="pi pi-search"
              onClick={() => {
                loadReasonOptions().then(() => {
                  setTimeout(() => reasonAutoCompleteRef.current?.show(), 0);
                });
              }}
            />
          </span>
        </div>
      );
      break;
    }
    case InvoiceField.nonTaxZone:
    case InvoiceField.isDeductionNQ43:
      input = (
        <div className="flex flex-wrap gap-3">
          {setting.options?.map((option, index) => (
            <div key={index} className="flex align-items-center">
              <RadioButton
                inputId={`${option.value}`}
                name={fieldName}
                value={option.value}
                onChange={(e) =>
                  patchItem(setting.groupTypeCode, fieldName, e.value)
                }
                checked={inputProps.value === option.value}
              />
              <label htmlFor={`${option.value}`} className="ml-2">
                {option.translationKey ? t(option.translationKey) : option.label}
              </label>
            </div>
          ))}
        </div>
      );
      break;
    case InvoiceField.provinceCode:
    case InvoiceField.wardCode: {
      const locationTemplate = (option) => (
        <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
          {option.displayLabel || [option.code, option.name].filter(Boolean).join(" - ")}
        </div>
      );
      const onLocationChange = (e) => {
        if (typeof e.value === "string") {
          setSelectedLocation(null);
          setLocationSearch(e.value);
          if (!e.value) {
            // Khi người dùng xóa hết nội dung, phải xóa cả mã đã lưu để không hiển thị lại mã cũ.
            patchItem(setting.groupTypeCode, fieldName, "");
          }
          return;
        }

        const location = e.value && typeof e.value === "object" ? e.value : null;

        if (!location && e.value) {
          return;
        }

        setLocationSearch("");
        setSelectedLocation(location);
        patchItem(
          setting.groupTypeCode,
          fieldName,
          location?.code || "",
        );
      };

      input = (
        <div className="p-inputgroup">
          <AutoComplete
            {...inputProps}
            value={selectedLocation || locationSearch || inputProps.value || ""}
            suggestions={options}
            completeMethod={completeMethod}
            field="displayLabel"
            itemTemplate={locationTemplate}
            onChange={onLocationChange}
          />
          <span className="p-inputgroup-addon">
            <i
              className="pi pi-search"
              onClick={() => completeMethod({ query: "" })}
            />
          </span>
        </div>
      );
      break;
    }
    case InvoiceField.BuyerTaxCode:
      const taxCodeTemplate = (item) => {
        const labels = [];
        if (item.taxCode) {
          labels.push(item.taxCode);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return (
          <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
            {labels.join(" - ")}
          </div>
        );
      };
      const onTaxCodeChange = (e) => {
        if (e.value?.taxCode) {
          const tenantClient = e.value;
          patchItem(setting.groupTypeCode, fieldName, {
            buyerCode: tenantClient.code,
            buyerTaxCode: tenantClient.taxCode,
            buyerLegalName: tenantClient.name,
            buyerAddress: tenantClient.address,
            buyerEmail: tenantClient.email,
            buyerBankAccount: tenantClient.bankAccount,
            buyerBankName: tenantClient.bankName,
            buyerTel: tenantClient.mobile,
            buyerDisplayName: tenantClient.personContact,
          });
        } else {
          patchItem(setting.groupTypeCode, fieldName, e.value);
        }
      };
      input = (
        <div className="p-inputgroup">
          <AutoComplete
            {...inputProps}
            suggestions={options}
            completeMethod={completeMethod}
            field="taxCode"
            itemTemplate={taxCodeTemplate}
            onChange={onTaxCodeChange}
          />
          <span className="p-inputgroup-addon">
            <i className="pi pi-search" onClick={searchTaxCode} />
          </span>
        </div>
      );
      break;
    case InvoiceField.BuyerCode:
      const codeTemplate = (item) => {
        const labels = [];
        if (item.code) {
          labels.push(item.code);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return (
          <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
            {labels.join(" - ")}
          </div>
        );
      };
      input = (
        <div className="p-inputgroup">
          <AutoComplete
            {...inputProps}
            suggestions={options}
            completeMethod={completeMethod}
            field="name"
            itemTemplate={codeTemplate}
            onChange={(e) =>
              patchItem(setting.groupTypeCode, fieldName, e.value)
            }
          />
          <span className="p-inputgroup-addon">
            <i className="pi pi-plus" onClick={createTenantClient} />
          </span>
          {renderDialogTenantClient()}
        </div>
      );
      break;
    case InvoiceField.BuyerLegalName:
      const nameTemplate = (item) => {
        const labels = [];
        if (item.taxCode) {
          labels.push(item.taxCode);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return (
          <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
            {labels.join(" - ")}
          </div>
        );
      };
      const onNameChange = (e) => {
        if (e.value?.taxCode) {
          const tenantClient = e.value;
          patchItem(setting.groupTypeCode, fieldName, {
            buyerCode: tenantClient.code,
            buyerTaxCode: tenantClient.taxCode,
            buyerLegalName: tenantClient.name,
            buyerAddress: tenantClient.address,
            buyerEmail: tenantClient.email,
            buyerBankAccount: tenantClient.bankAccount,
            buyerBankName: tenantClient.bankName,
            buyerTel: tenantClient.mobile,
            buyerDisplayName: tenantClient.personContact,
          });
        } else {
          patchItem(setting.groupTypeCode, fieldName, e.value);
        }
      };
      input = (
        <AutoComplete
          {...inputProps}
          suggestions={options}
          completeMethod={completeMethod}
          field="name"
          itemTemplate={nameTemplate}
          onChange={onNameChange}
        />
      );
      break;
    default:
      switch (setting.dataType) {
        case "int32":
          const fractionDigits = getFormat(setting);
          input = (
            <InputNumber
              locale={FormatDisplay.locales}
              inputId={fieldName}
              {...inputProps}
              onChange={(e) =>
                patchItem(setting.groupTypeCode, fieldName, e.value)
              }
              minFractionDigits={fractionDigits}
              maxFractionDigits={fractionDigits}
            />
          );
          break;
        case "string":
          input = inputText;
          break;
        case "datetime":
          input = (
            <Calendar
              id={fieldName}
              {...inputProps}
              onChange={(e) =>
                patchItem(setting.groupTypeCode, fieldName, e.value)
              }
              dateFormat="dd/mm/yy"
            />
          );
          break;
        default:
          console.log(setting);
      }
  }

  if (gridType === "percent") {
    return (
      <Fragment>
        {fieldName === InvoiceField.BuyerTaxCode && taxCodeStatus}
        <label
          htmlFor={fieldName}
          className={`col-12 mb-2 md:mb-0`}
          style={{ width: setting.lableWidth + "%" }}
        >
          {setting.labelTranslationKey ? t(setting.labelTranslationKey) : setting.lable}
          {required}
        </label>
        <div className={`col-12`} style={{ width: setting.controlWidth + "%" }}>
          {input}
          {!!(validators && validators[fieldName]) && (
            <small className="text-red-500">{validators[fieldName]}</small>
          )}
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        {fieldName === InvoiceField.BuyerTaxCode && taxCodeStatus}
        <label
          htmlFor={fieldName}
          className={`col-12 mb-2 md:col-${setting.lableWidth} md:mb-0`}
        >
          {setting.labelTranslationKey ? t(setting.labelTranslationKey) : setting.lable}
          {required}
        </label>
        <div className={`col-12 md:col-${setting.controlWidth}`}>
          {input}
          {!!(validators && validators[fieldName]) && (
            <small className="text-red-500">{validators[fieldName]}</small>
          )}
        </div>
      </Fragment>
    );
  }
};
